(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('zen-stock-availability')) {
customElements.define('zen-stock-availability', class extends HTMLElement {
connectedCallback() {
if (this.dataset.ready) return;
this.dataset.ready = 'true';
this.select = document.getElementById(this.dataset.selectId);
this.quantityInput = document.getElementById(this.dataset.quantityId);
this.message = this.querySelector('[data-stock-message]');
if (this.select) this.select.addEventListener('change', () => this.update());
this.update();
}
update() {
const option = this.select ? this.select.selectedOptions[0] : null;
const tracked = option ? option.dataset.stockTracked === 'true' : this.dataset.currentTracked === 'true';
const available = option ? option.dataset.stockAvailable === 'true' : this.dataset.currentAvailable === 'true';
const policy = option ? option.dataset.stockPolicy : this.dataset.currentPolicy;
const quantity = Number(option ? option.dataset.stockQuantity : this.dataset.currentQuantity);
let text = this.dataset.soldOut;
if (!tracked && available) text = this.dataset.inStock;
if (tracked && quantity === 1) text = this.dataset.oneLeft;
if (tracked && quantity > 1) text = this.dataset.manyLeft.replace('[count]', String(quantity));
if (tracked && quantity < 1 && available && policy === 'continue') text = this.dataset.availableOrder;
this.message.textContent = text;
if (this.quantityInput) {
if (tracked && policy === 'deny' && quantity > 0) {
this.quantityInput.max = String(quantity);
if (Number(this.quantityInput.value) > quantity) this.quantityInput.value = String(quantity);
} else {
this.quantityInput.removeAttribute('max');
}
}
}
});
}
if (!customElements.get('zen-product-gallery')) {
customElements.define('zen-product-gallery', class extends HTMLElement {
connectedCallback() {
if (this.dataset.ready) return;
this.dataset.ready = 'true';
this.addEventListener('click', event => {
const button = event.target.closest('[data-gallery-index]');
if (!button || !this.contains(button)) return;
this.querySelectorAll('[data-gallery-panel]').forEach(panel => { panel.hidden = panel.dataset.galleryPanel !== button.dataset.galleryIndex; });
this.querySelectorAll('[data-gallery-index]').forEach(thumbnail => { thumbnail.setAttribute('aria-pressed', String(thumbnail === button)); });
});
}
});
}

  } catch(e) { console.error(e); }
})();
})();
